const members = {
  // 会员首页
  homePage: `/userApi/v1/UserVip/homePage`,
  // 兑换会员
  exchangeMembers: `/userApi/v1/UserVip/exchangeMembers`,
  // 会员购买记录
  buyRecord: `/userApi/v1/UserVip/buyRecord`,
  // 会员签到领取充值券
  signReceive: `/userApi/v1/UserVip/signReceive`,
  // 余额明细
  balanceDetails: `/userApi/v1/userFission/balanceDetails`,
  // 游戏标签列表
  gameTags: `/userApi/v1/userFission/gameTags`,
  // 充值券充值游戏
  couponRecharge: `/userApi/v1/userFission/couponRecharge`,
  // 充值页面
  rechargePage: `/authApi/box/v1/userFission/rechargePage`,
  // 充值会员-支付宝扫码
  QrAlipayVip: `/payApi/v1/Pay/QrAlipayVip`,
  // 充值会员-微信扫码
  QrWechatVip: `/payApi/v1/Pay/QrWechatVip`
};

export default members;
